import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

export default class EmptyMessage extends Component {
    static propTypes = {
        message: PropTypes.any,
    };

    static defaultProps = {
        message: 'No hay datos disponibles.',
    };

    render() {
        return (
            <div className={styles.root}>
                {this.props.message}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/empty-message/index.js